export default "__VITE_ASSET__DDd5UQq9__"